import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { UserPlus } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ContractScopeSelector } from '@/components/users/contract-scope-selector';
import { ContractSettings } from './contract-settings';
import { useFormContext } from 'react-hook-form';
import { useAppSelector } from '@/store';

export function PropertyAdminUser() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const { watch, setValue } = useFormContext();

  // Get property_type_id from Redux store (saved in step 1)
  const persistedData = useAppSelector(
    state => state.propertyCreate?.formData || {}
  );
  const propertyTypeId = persistedData.property_type_id;

  const contractScope = watch('contractScope');
  const selectedDepartmentTouchpoints =
    watch('selectedDepartmentTouchpoints') || [];

  const handleScopeChange = (
    scope: { departmentId: string; touchpointIds: string[] }[]
  ) => {
    setValue('selectedDepartmentTouchpoints', scope);
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle
            className={cn(
              'flex items-center gap-2',
              isRTL ? 'flex-row-reverse' : 'flex-row'
            )}
          >
            <UserPlus className="w-5 h-5" />
            {t('properties.create.adminUser.title')}
          </CardTitle>
          <CardDescription className={isRTL ? 'text-right' : 'text-left'}>
            {t('properties.create.adminUser.description')}
          </CardDescription>
        </CardHeader>
      </Card>

      <ContractSettings />

      {contractScope === 'limited' && propertyTypeId && (
        <ContractScopeSelector
          propertyTypeId={propertyTypeId}
          selectedScope={selectedDepartmentTouchpoints}
          onScopeChange={handleScopeChange}
        />
      )}
    </div>
  );
}
